require("!!/Users/pabloqueme/Documents/GitHub/lexglobal-frontend/node_modules/script-loader/addScript.js")(require("!!/Users/pabloqueme/Documents/GitHub/lexglobal-frontend/node_modules/raw-loader/index.js!/Users/pabloqueme/Documents/GitHub/lexglobal-frontend/node_modules/sortablejs/Sortable.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/sortablejs/Sortable.js
// module id = 942
// module chunks = 3